import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from 'redux';
import { MerchantList, AccountList, AccountDetail, AccountEdit } from './components';
import { AccountActions, NotificationActions } from '../../store';

const style = theme => ({
    root: {
        height: '100%'
    },
    visibleList: {
        height: '100%',
        visibility: 'visible'
    },
    hiddenList: {
        height: '100%',
        visibility: 'hidden'
    }
})

const IdentitySelector = (state) => state.Identity;

const Account = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const accountActions = bindActionCreators(AccountActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    // トークンID, ユーザ情報を取得
    const { token, userData } = useSelector(IdentitySelector);

    // 画面モードと併せて、選択した加盟店情報、加盟店一覧とアカウント一覧のフィルタリング情報も保持
    const [modeInfo, setModeInfo] = useState({
        // モード
        mode: 'mlist'
        // 選択した加盟店情報（加盟店ID、加盟店名、加盟店タイプ）
        , merchant_id: '', merchant_name: '', merchant_type: ''
        // 加盟店一覧のフィルタリング情報（加盟店名、加盟店タイプ）
        , m_merchant_name: '', m_merchant_type: ''
        // アカウント一覧のフィルタリング情報（アカウント名、ロール、所属名、ステータス）
        , a_account_name: '', a_role: '', a_org_name: '', a_status: ''
    });
    const [listRefresh, setListRefresh] = useState(true);

    const { classes } = props;

    /**
     *
     * アカウント一覧画面表示
     *
     * @param data 選択された行のデータ
     */
    const showAccountList = (data, merchantName, merchantType) => {
        if (data == null || data == undefined) {
            // 編集画面などからも戻るボタンでの遷移時
            setModeInfo({
                mode: 'list'
                , merchant_id: modeInfo.merchant_id, merchant_name: modeInfo.merchant_name, merchant_type: modeInfo.merchant_type
                , m_merchant_name: modeInfo.m_merchant_name, m_merchant_type: modeInfo.m_merchant_type
                , a_account_name: modeInfo.a_account_name, a_role: modeInfo.a_role, a_org_name: modeInfo.a_org_name, a_status: modeInfo.a_status
            })
        }
        else {
            // 加盟店一覧から遷移時
            // storeに選択した加盟店のアカウントリストを要求
            accountActions.listAccounts(token, data.id)
                .then(res => {
                    // 取得したアカウント一覧を表示
                    setModeInfo({
                        mode: 'list'
                        , merchant_id: data.id, merchant_name: data.merchant_name, merchant_type: data.merchant_type
                        , m_merchant_name: merchantName, m_merchant_type: merchantType
                        , a_account_name: '', a_role: '', a_org_name: '', a_status: ''
                    })
                })
                .catch(e => {
                    notificationActions.showError(e.message);
                });
        }
    }

    /**
     *
     * 詳細画面表示
     *
     * @param data 選択された行のデータ
     */
    const showDetail = (data, accountName, role, orgName, status) => {
        // 対象のアカウントIDのアカウント情報を取得
        accountActions.loadEditModel(token, data.id, null)
            .then(data => {
                // 詳細画面に表示切替
                setModeInfo({
                    mode: 'detail'
                    , merchant_id: modeInfo.merchant_id, merchant_name: modeInfo.merchant_name, merchant_type: modeInfo.merchant_type
                    , m_merchant_name: modeInfo.m_merchant_name, m_merchant_type: modeInfo.m_merchant_type
                    , a_account_name: accountName, a_role: role, a_org_name: orgName, a_status: status
                });
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     *
     * 加盟店リスト画面表示
     *
     */
    const showList = (accountName, role, orgName, status) => {
        setListRefresh(false);
        setModeInfo({
            mode: 'mlist'
            , merchant_id: modeInfo.merchant_id, merchant_name: modeInfo.merchant_name, merchant_type: modeInfo.merchant_type
            , m_merchant_name: modeInfo.m_merchant_name, m_merchant_type: modeInfo.m_merchant_type
            , a_account_name: accountName, a_role: role, a_org_name: orgName, a_status: status
        });
    }

    /**
     *
     * 編集画面表示
     *
     */
    const showEdit = () => {
        setModeInfo({
            mode: 'edit'
            , merchant_id: modeInfo.merchant_id, merchant_name: modeInfo.merchant_name, merchant_type: modeInfo.merchant_type
            , m_merchant_name: modeInfo.m_merchant_name, m_merchant_type: modeInfo.m_merchant_type
            , a_account_name: modeInfo.a_account_name, a_role: modeInfo.a_role, a_org_name: modeInfo.a_org_name, a_status: modeInfo.a_status
        });
    }

    /**
     *
     * 新規画面表示
     *
     */
    const showCreate = (accountName, role, orgName, status) => {
        // 新規作成用データ取得
        accountActions.loadEditModel(token, null, modeInfo.merchant_id)
            .then(data => {
                setModeInfo({
                    mode: 'create'
                    , merchant_id: modeInfo.merchant_id, merchant_name: modeInfo.merchant_name, merchant_type: modeInfo.merchant_type
                    , m_merchant_name: modeInfo.m_merchant_name, m_merchant_type: modeInfo.m_merchant_type
                    , a_account_name: accountName, a_role: role, a_org_name: orgName, a_status: status
                });
            })
            .catch(e => {
                notificationActions.showError(`新規作成データを取得できませんでした。${e.message}`);
            });
    }

    /**
     *
     * 詳細画面表示
     * （編集画面から詳細画面戻る際）
     *
     */
    const showDetailBack = () => {
        // 詳細画面を再表示
        setModeInfo({
            mode: 'detail'
            , merchant_id: modeInfo.merchant_id, merchant_name: modeInfo.merchant_name, merchant_type: modeInfo.merchant_type
            , m_merchant_name: modeInfo.m_merchant_name, m_merchant_type: modeInfo.m_merchant_type
            , a_account_name: modeInfo.a_account_name, a_role: modeInfo.a_role, a_org_name: modeInfo.a_org_name, a_status: modeInfo.a_status
        })
    }

    var listClass = classes.hiddenList;
    if (modeInfo.mode == 'mlist') {
        listClass = classes.visibleList;
    }
    var content = <div></div>;

    //　通常の代表加盟店（MC代表加盟店以外）の場合、アカウント一覧を表示（加盟店一覧は表示しない）
    if (modeInfo.mode == 'mlist' && userData != null && userData.role == 3 && userData.org_id != '00000000-0000-0000-0000-000000000001') {
        // 通常の代表加盟店ユーザ（MC代表加盟店以外）でログインされた場合は、加盟店一覧表示は行わずにアカウント一覧を表示
        //（ログインしているユーザの加盟店IDで表示）
        setModeInfo({
            mode: 'list'
            , merchant_id: userData.org_id, merchant_name: userData.org_name, merchant_type: 'acquirer'
            , m_merchant_name: modeInfo.m_merchant_name, m_merchant_type: modeInfo.m_merchant_type
            , a_account_name: modeInfo.a_account_name, a_role: modeInfo.a_role, a_org_name: modeInfo.a_org_name, a_status: modeInfo.a_status
        });
    }

    //　加盟店の場合、アカウント一覧を表示（加盟店一覧は表示しない）
    if (modeInfo.mode == 'mlist' && userData != null && userData.role == 4) {
        // 加盟店ユーザでログインされた場合は、加盟店一覧表示は行わずにアカウント一覧を表示
        //（ログインしているユーザの加盟店IDで表示）
        setModeInfo({
            mode: 'list'
            , merchant_id: userData.org_id, merchant_name: userData.org_name, merchant_type: 'general'
            , m_merchant_name: modeInfo.m_merchant_name, m_merchant_type: modeInfo.m_merchant_type
            , a_account_name: modeInfo.a_account_name, a_role: modeInfo.a_role, a_org_name: modeInfo.a_org_name, a_status: modeInfo.a_status
        });
    }

    if (modeInfo.mode == 'list') {
        // アカウント一覧表示
        // 詳細画面用に戻るボタン（加盟店一覧画面）、追加ボタン（新規追加）、編集ボタン（編集画面）用のデリゲートを設定
        content = <AccountList onCancel={showList} onCreate={showCreate} onDetail={showDetail} refresh={listRefresh}
            merchantId={modeInfo.merchant_id} merchantName={modeInfo.merchant_name} merchantType={modeInfo.merchant_type}
            accountName={modeInfo.a_account_name} role={modeInfo.a_role} orgName={modeInfo.a_org_name} status={modeInfo.a_status} />
    }
    if (modeInfo.mode == 'detail') {
        // 詳細画面表示
        // 詳細画面用に戻るボタン（一覧画面）、編集ボタン（編集画面）用のデリゲートを設定
        content = <AccountDetail onCancel={showAccountList} onEdit={showEdit} />
    }
    if (modeInfo.mode == 'edit') {
        // 編集画面表示
        // 編集画面用に戻るボタン（詳細画面）、登録ボタン（詳細画面）用のデリゲートを設定
        content = <AccountEdit createFlag={false} onCancel={showDetailBack} onUpdate={showDetailBack}
            merchantId={modeInfo.merchant_id} merchantName={modeInfo.merchant_name} merchantType={modeInfo.merchant_type} />
    }
    if (modeInfo.mode == 'create') {
        // 新規追加画面表示
        // 新規作成画面用に戻るボタン（一覧画面）用のデリゲートを設定
        content = <AccountEdit createFlag={true} onCancel={showAccountList} onUpdate={showAccountList}
            merchantId={modeInfo.merchant_id} merchantName={modeInfo.merchant_name} merchantType={modeInfo.merchant_type} />
    }

    return (
        <div className={classes.root} maxWidth={false}>
            {content}
            <div className={listClass}>
                <MerchantList onList={showAccountList} refresh={listRefresh}
                    merchantNameSearch={modeInfo.m_merchant_name} merchantTypeSearch={modeInfo.m_merchant_type} />
            </div>
        </div>
    )
}

export default withStyles(style, { withTheme: true })(Account);
